<template>
  <v-row dense>
    <v-col cols="12">
      <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="ARMAZEM"
          label="Armazém"
          required
          :disabled="readonly"
          class="required rounded-tag-small"
          v-model="formData.armazem">
        <template v-slot:append-outer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon
                     v-on="on"
                     :disabled="!formData.armazem"
                     @click="onClickReplicarCampo(formData.armazem)">
                <v-icon class="pb-2" v-on="on">
                  mdi-clipboard-arrow-down
                </v-icon>
              </v-btn>
            </template>
            <span>Replicar campo aos outros produtos</span>
          </v-tooltip>
        </template>
      </px-autocomplete-cadastro-adicional>
    </v-col>
    <v-col cols="12">
      <px-autocomplete-cadastro-adicional
        :dense="dense"
        type="CONTA_CONTABIL"
        label="Conta contábil"
        required
        class="required rounded-tag-small"
        :disabled="readonly"
        v-model="formData.contaContabil">
        <template v-slot:append-outer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon
                     v-on="on"
                     :disabled="!formData.contaContabil"
                     @click="onClickReplicarCampo(formData.contaContabil)">
                <v-icon class="pb-2" v-on="on">
                  mdi-clipboard-arrow-down
                </v-icon>
              </v-btn>
            </template>
            <span>Replicar campo aos outros produtos</span>
          </v-tooltip>
        </template>
      </px-autocomplete-cadastro-adicional>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickReplicarCampo(campo) {
      this.$emit('replicar-campo', campo);
    },
  },
};
</script>
